import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Button, Card, Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
function Home() {
  return (
    <Container fluid className="home-container">
      <Row>
        <Col sm={12}>
          <h1 className="text-center mt-2 mt-lg-5 mobileViewSet">
            Info: Ambassador<span className="text-primary">4</span>
            <span style={{ color: "red" }}>Brand</span>
          </h1>

          <Card className="p-3 my-4 mx-auto" style={{ maxWidth: "600px" }}>
            <div className="text-center term-and-condition-main">
              <p className="termsPoint">
                1. Student Athletes are Brand Ambassadors here to help Fans.
              </p>
              <p className="termsPoint">
                2. They can teach you how to use our websites & Programs.
              </p>
              <p className="termsPoint">
                3. You can choose which Student Athlete Brand Ambassador you
                want for your teacher.
              </p>
              <p className="termsPoint">
                4. They get paid from your PayPal by the minutes of chat you
                choose.
              </p>
            </div>
          </Card>

          <div className="text-center mb-4">
            <a
              href="https://youtu.be/uIWftF7cjug"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h5>https://youtu.be/uIWftF7cjug</h5>
            </a>
          </div>

          <Card className="p-3 my-4 mx-auto" style={{ maxWidth: "850px" }}>
            <h2 className="text-center home-title">
              Hi Fans, You can learn about Question Topics, Lesson name & System
              Parts:
            </h2>
            <div className="pt-3 text-center">
              <Row className="justify-content-center">
                <Col xs="12" md="4" className="mb-2 mb-md-0">
                  <Link to="/terms-and-condition">
                    <Button
                      color="primary"
                      className="login-btn text-white w-100"
                    >
                      Topics
                    </Button>
                  </Link>
                </Col>
                <Col xs="12" md="4" className="mb-2 mb-md-0">
                  <Link to="/learn-with-expert">
                    <Button
                      color="primary"
                      className="login-btn text-white w-100"
                    >
                      Lesson names
                    </Button>
                  </Link>
                </Col>
                <Col xs="12" md="4">
                  <Link to="/summary">
                    <Button
                      color="primary"
                      className="login-btn text-white w-100"
                    >
                      System
                    </Button>
                  </Link>
                </Col>
              </Row>
            </div>
          </Card>

          <Card className="p-3 my-4 mx-auto" style={{ maxWidth: "600px" }}>
            <h2 className="text-center home-title text-primary">IMPORTANT</h2>
            <p className="home-important-text text-center">
              During CHAT, please comply with rules of NCAA/amateur sports. Best
              not to discuss Gambling, Recruitment, Transfer Portal, alcohol,
              drugs, or other subject matter which could violate regulations.
            </p>
          </Card>

          <h5 className="mx-3 mx-sm-5 px-1 px-sm-2 text-center home-note-text">
            <b>Note:&nbsp;</b>The opinions offererd by teacher-athletes in their
            answers are not guaranteed to be accurate.For legal advice regarding
            amateur sport, please consult your own attorney.
          </h5>

          <div className="text-center mt-3">
            <p className="home-note-text">
              <span className="d-flex justify-content-center align-items-center flex-wrap">
                Continue:
                <strong className="mx-1 mb-0">
                  <Link to="/Login">
                    <span className="text-primary">Login</span>
                  </Link>
                </strong>
                <span>to select Your BRAND AMBASSADOR / STUDENT ATHLETE</span>
              </span>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Home;
